import { Product } from '~/commons/interfaces/models/content/product/Product'

export function getProductManufacturerName(
  product: Product
): string | undefined | null {
  return product.manufacturer?.translated?.name
}
